import React from 'react';

const ChartPieIcon = ({ fill }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0.0618896V9H15.9381C15.446 12.9463 12.0796 16 8 16C3.58172 16 0 12.4183 0 8C0 3.92038 3.05369 0.553988 7 0.0618896Z" fill={fill} />
      <path d="M9 0.0618897V7H15.9381C15.4869 3.38128 12.6187 0.513137 9 0.0618897Z" fill={fill} />
    </svg>
  );
};

export default ChartPieIcon;
